import login from "@/api/login";
import mentor from "@/api/mentor";
const request = {
  login,
  mentor
};
const api = (module, method, params) => {
  return request[module][method](params);
};
export default api;
